// 完全禁用 wowjs：把它的核心方法变成空函数
import { WOW } from 'wowjs'
WOW.prototype.init = function () {}
WOW.prototype.scrollCallback = function () {}
WOW.prototype.resetAnimation = function () {}


// WEBPACK FOOTER //
// ./src/plugins/wow-off.js